import {DocumentChoice} from './types';

export function getDocumentsListAsOptions(documents?: DocumentChoice[]) {
  if (!documents?.length) {
    return [];
  }

  return documents.map(doc => {
    return {
      label: doc.label,
      value: doc.value,
      data: doc,
    };
  });
}
